import request from './request'

// ==================== FAQ 分类 ====================

/**
 * 获取FAQ分类树
 */
export function getFaqCategoryTree() {
  return request.get('/kb/faq/categories/tree')
}

/**
 * 新增FAQ分类
 * @param {object} data - { parentId, name, sort, status, remark }
 */
export function createFaqCategory(data) {
  return request.post('/kb/faq/categories', data)
}

/**
 * 修改FAQ分类
 * @param {number} id - 分类ID
 * @param {object} data - { id, parentId, name, sort, status, remark }
 */
export function updateFaqCategory(id, data) {
  return request.put(`/kb/faq/categories/${id}`, { ...data, id })
}

/**
 * 删除FAQ分类
 * @param {number} id - 分类ID
 */
export function deleteFaqCategory(id) {
  return request.delete(`/kb/faq/categories/${id}`)
}

// ==================== FAQ 条目 ====================

/**
 * 分页查询FAQ列表
 * @param {object} params - { categoryId, keyword, status, page, size }
 */
export function getFaqItemPage(params) {
  return request.get('/kb/faq/items', { params })
}

/**
 * 获取FAQ详情
 * @param {number} id - FAQ条目ID
 */
export function getFaqItemDetail(id) {
  return request.get(`/kb/faq/items/${id}`)
}

/**
 * 新增FAQ
 * @param {object} data - { categoryId, title, content, tags, status, isTop, remark }
 */
export function createFaqItem(data) {
  return request.post('/kb/faq/items', data)
}

/**
 * 编辑FAQ
 * @param {number} id - FAQ条目ID
 * @param {object} data - { id, categoryId, title, content, tags, status, isTop, remark }
 */
export function updateFaqItem(id, data) {
  return request.put(`/kb/faq/items/${id}`, { ...data, id })
}

/**
 * 删除FAQ
 * @param {number} id - FAQ条目ID
 */
export function deleteFaqItem(id) {
  return request.delete(`/kb/faq/items/${id}`)
}

/**
 * 发布FAQ
 * @param {number} id - FAQ条目ID
 */
export function publishFaqItem(id) {
  return request.put(`/kb/faq/items/${id}/publish`)
}

/**
 * 归档FAQ
 * @param {number} id - FAQ条目ID
 */
export function archiveFaqItem(id) {
  return request.put(`/kb/faq/items/${id}/archive`)
}

/**
 * 置顶/取消置顶FAQ
 * @param {number} id - FAQ条目ID
 */
export function toggleFaqItemTop(id) {
  return request.put(`/kb/faq/items/${id}/top`)
}

// ==================== FAQ 版本 ====================

/**
 * 获取FAQ版本列表
 * @param {number} id - FAQ条目ID
 */
export function getFaqVersions(id) {
  return request.get(`/kb/faq/items/${id}/versions`)
}

/**
 * 查看指定版本内容
 * @param {number} id - FAQ条目ID
 * @param {number} version - 版本号
 */
export function getFaqVersionDetail(id, version) {
  return request.get(`/kb/faq/items/${id}/versions/${version}`)
}

/**
 * 回滚到指定版本
 * @param {number} id - FAQ条目ID
 * @param {number} targetVersion - 目标版本号
 */
export function rollbackFaqItem(id, targetVersion) {
  return request.post(`/kb/faq/items/${id}/rollback`, { faqId: id, targetVersion })
}

// ==================== FAQ 互动 ====================

/**
 * 提交评价
 * @param {number} id - FAQ条目ID
 * @param {boolean} helpful - 是否有用
 */
export function submitFaqFeedback(id, helpful) {
  return request.post(`/kb/faq/items/${id}/feedback`, { helpful })
}

/**
 * 获取关联FAQ列表
 * @param {number} id - FAQ条目ID
 */
export function getFaqRelated(id) {
  return request.get(`/kb/faq/items/${id}/related`)
}

/**
 * 设置关联FAQ
 * @param {number} id - FAQ条目ID
 * @param {number[]} relatedIds - 关联FAQ ID列表
 */
export function setFaqRelated(id, relatedIds) {
  return request.put(`/kb/faq/items/${id}/related`, { relatedIds })
}

/**
 * 热门FAQ
 */
export function getFaqHot() {
  return request.get('/kb/faq/hot')
}

// ==================== 合同范本分类 ====================

/**
 * 获取合同分类树
 */
export function getContractCategoryTree() {
  return request.get('/kb/contract/categories/tree')
}

/**
 * 新增合同分类
 * @param {object} data - { parentId, name, sort, status }
 */
export function createContractCategory(data) {
  return request.post('/kb/contract/categories', data)
}

/**
 * 修改合同分类
 * @param {number} id - 分类ID
 * @param {object} data - { id, parentId, name, sort, status }
 */
export function updateContractCategory(id, data) {
  return request.put(`/kb/contract/categories/${id}`, data)
}

/**
 * 删除合同分类
 */
export function deleteContractCategory(id) {
  return request.delete(`/kb/contract/categories/${id}`)
}

// ==================== 合同范本 ====================

/**
 * 分页查询合同范本
 * @param {object} params - { categoryId, keyword, status, page, size }
 */
export function getContractTemplatePage(params) {
  return request.get('/kb/contract/templates', { params })
}

/**
 * 获取合同范本详情
 */
export function getContractTemplateDetail(id) {
  return request.get(`/kb/contract/templates/${id}`)
}

/**
 * 新增合同范本
 */
export function createContractTemplate(data) {
  return request.post('/kb/contract/templates', data)
}

/**
 * 修改合同范本基本信息
 */
export function updateContractTemplate(id, data) {
  return request.put(`/kb/contract/templates/${id}`, data)
}

/**
 * 删除合同范本
 */
export function deleteContractTemplate(id) {
  return request.delete(`/kb/contract/templates/${id}`)
}

/**
 * 发布合同范本
 */
export function publishContractTemplate(id) {
  return request.put(`/kb/contract/templates/${id}/publish`)
}

/**
 * 废止合同范本
 */
export function deprecateContractTemplate(id) {
  return request.put(`/kb/contract/templates/${id}/deprecate`)
}

// ==================== 合同范本版本 ====================

/**
 * 获取合同版本列表
 */
export function getContractVersions(id) {
  return request.get(`/kb/contract/templates/${id}/versions`)
}

/**
 * 获取指定版本详情
 */
export function getContractVersionDetail(id, version) {
  return request.get(`/kb/contract/templates/${id}/versions/${version}`)
}

/**
 * 创建新版本
 * @param {number} id - 模板ID
 * @param {object} data - { templateId, changeSummary }
 */
export function createContractVersion(id, data) {
  return request.post(`/kb/contract/templates/${id}/versions`, { templateId: id, ...data })
}

/**
 * 回滚合同版本
 */
export function rollbackContractTemplate(id, targetVersion) {
  return request.post(`/kb/contract/templates/${id}/rollback`, { targetVersion })
}

// ==================== 合同附件下载/预览 ====================

/**
 * 下载合同附件
 * @param {number} attachmentId - 附件ID
 */
export function downloadContractAttachment(attachmentId) {
  return request.get(`/kb/contract/attachments/${attachmentId}/download`, {
    responseType: 'blob'
  })
}

/**
 * 预览合同附件 - 获取文件流
 * @param {number} attachmentId - 附件ID
 */
export function previewContractAttachment(attachmentId) {
  return request.get(`/kb/contract/attachments/${attachmentId}/preview`, {
    responseType: 'blob'
  })
}

/**
 * 删除合同附件
 * @param {number} attachmentId - 附件ID
 */
export function deleteContractAttachment(attachmentId) {
  return request.delete(`/kb/contract/attachments/${attachmentId}`)
}

/**
 * 新增合同附件
 * @param {number} templateId - 模板ID
 * @param {object} data - 附件信息
 */
export function addContractAttachment(templateId, data) {
  return request.post(`/kb/contract/templates/${templateId}/attachments`, data)
}

/**
 * 查询下载记录
 */
export function getContractDownloadLogs(id, params) {
  return request.get(`/kb/contract/templates/${id}/download-logs`, { params })
}

// ==================== 政策法规分类 ====================

/**
 * 获取政策法规分类树
 */
export function getPolicyCategoryTree() {
  return request.get('/kb/policy/categories/tree')
}

/**
 * 新增政策法规分类
 * @param {object} data - { parentId, name, sort, status }
 */
export function createPolicyCategory(data) {
  return request.post('/kb/policy/categories', data)
}

/**
 * 修改政策法规分类
 * @param {number} id - 分类ID
 * @param {object} data - { id, parentId, name, sort, status }
 */
export function updatePolicyCategory(id, data) {
  return request.put(`/kb/policy/categories/${id}`, data)
}

/**
 * 删除政策法规分类
 */
export function deletePolicyCategory(id) {
  return request.delete(`/kb/policy/categories/${id}`)
}

// ==================== 政策法规 ====================

/**
 * 分页查询政策法规
 * @param {object} params - { categoryId, keyword, status, issuingAuthority, effectiveDateFrom, effectiveDateTo, urgencyLevel, page, size }
 */
export function getPolicyRegulationPage(params) {
  return request.get('/kb/policy/regulations', { params })
}

/**
 * 获取政策法规详情
 */
export function getPolicyRegulationDetail(id) {
  return request.get(`/kb/policy/regulations/${id}`)
}

/**
 * 新增政策法规
 */
export function createPolicyRegulation(data) {
  return request.post('/kb/policy/regulations', data)
}

/**
 * 编辑政策法规（自动产生新版本）
 */
export function updatePolicyRegulation(id, data) {
  return request.put(`/kb/policy/regulations/${id}`, data)
}

/**
 * 删除政策法规
 */
export function deletePolicyRegulation(id) {
  return request.delete(`/kb/policy/regulations/${id}`)
}

/**
 * 发布政策法规
 */
export function publishPolicyRegulation(id) {
  return request.put(`/kb/policy/regulations/${id}/publish`)
}

/**
 * 标记政策失效
 */
export function invalidatePolicyRegulation(id) {
  return request.put(`/kb/policy/regulations/${id}/invalidate`)
}

// ==================== 政策法规版本 ====================

/**
 * 获取政策版本列表
 */
export function getPolicyVersions(id) {
  return request.get(`/kb/policy/regulations/${id}/versions`)
}

/**
 * 获取指定版本内容
 */
export function getPolicyVersionDetail(id, version) {
  return request.get(`/kb/policy/regulations/${id}/versions/${version}`)
}

/**
 * 回滚政策版本
 * @param {number} id - 政策法规ID
 * @param {number} targetVersion - 目标版本号
 */
export function rollbackPolicyRegulation(id, targetVersion) {
  return request.post(`/kb/policy/regulations/${id}/rollback`, { policyId: id, targetVersion })
}

// ==================== 政策通知 ====================

/**
 * 发送通知
 * @param {number} id - 政策法规ID
 * @param {object} data - { scope, scopeTarget }
 */
export function sendPolicyNotify(id, data) {
  return request.post(`/kb/policy/regulations/${id}/notify`, data)
}

/**
 * 查询通知记录
 */
export function getPolicyNotifyRecords(id) {
  return request.get(`/kb/policy/regulations/${id}/notify-records`)
}

/**
 * 查询替代链
 */
export function getPolicySupersederChain(id) {
  return request.get(`/kb/policy/regulations/${id}/supersede-chain`)
}

// ==================== 政策法规附件 ====================

/**
 * 下载政策法规附件
 * @param {number} attachmentId - 附件ID
 */
export function downloadPolicyAttachment(attachmentId) {
  return request.get(`/kb/policy/attachments/${attachmentId}/download`, {
    responseType: 'blob'
  })
}

/**
 * 预览政策法规附件 - 获取文件流
 * @param {number} attachmentId - 附件ID
 */
export function previewPolicyAttachment(attachmentId) {
  return request.get(`/kb/policy/attachments/${attachmentId}/preview`, {
    responseType: 'blob'
  })
}

// ==================== 共享接口 ====================

/**
 * 全局搜索
 * @param {object} params - { keyword, type, page, size }
 */
export function kbSearch(params) {
  return request.get('/kb/search', { params })
}

/**
 * 搜索建议
 * @param {string} keyword - 关键词
 */
export function kbSearchSuggest(keyword) {
  return request.get('/kb/search/suggest', { params: { keyword } })
}

// ==================== 资讯分类 ====================

/**
 * 获取资讯分类树
 */
export function getArticleCategoryTree() {
  return request.get('/kb/article/categories/tree')
}

/**
 * 新增资讯分类
 * @param {object} data - { parentId, name, sort, status, remark }
 */
export function createArticleCategory(data) {
  return request.post('/kb/article/categories', data)
}

/**
 * 修改资讯分类
 * @param {number} id - 分类ID
 * @param {object} data - { id, parentId, name, sort, status, remark }
 */
export function updateArticleCategory(id, data) {
  return request.put(`/kb/article/categories/${id}`, { ...data, id })
}

/**
 * 删除资讯分类
 * @param {number} id - 分类ID
 */
export function deleteArticleCategory(id) {
  return request.delete(`/kb/article/categories/${id}`)
}

// ==================== 资讯 ====================

/**
 * 分页查询资讯列表
 * @param {object} params - { categoryId, keyword, status, isTop, page, size }
 */
export function getArticlePage(params) {
  return request.get('/kb/article/list', { params })
}

/**
 * 获取资讯详情
 * @param {number} id - 资讯ID
 */
export function getArticleDetail(id) {
  return request.get(`/kb/article/${id}`)
}

/**
 * 创建资讯
 * @param {object} data - { categoryId, title, summary, content, coverImage }
 */
export function createArticle(data) {
  return request.post('/kb/article', data)
}

/**
 * 更新资讯
 * @param {number} id - 资讯ID
 * @param {object} data - { id, categoryId, title, summary, content, coverImage }
 */
export function updateArticle(id, data) {
  return request.put(`/kb/article/${id}`, { ...data, id })
}

/**
 * 删除资讯
 * @param {number} id - 资讯ID
 */
export function deleteArticle(id) {
  return request.delete(`/kb/article/${id}`)
}

/**
 * 发布资讯
 * @param {number} id - 资讯ID
 */
export function publishArticle(id) {
  return request.put(`/kb/article/${id}/publish`)
}

/**
 * 下架资讯
 * @param {number} id - 资讯ID
 */
export function offlineArticle(id) {
  return request.put(`/kb/article/${id}/offline`)
}

/**
 * 上架资讯
 * @param {number} id - 资讯ID
 */
export function onlineArticle(id) {
  return request.put(`/kb/article/${id}/online`)
}

/**
 * 切换资讯置顶状态
 * @param {number} id - 资讯ID
 */
export function toggleArticleTop(id) {
  return request.put(`/kb/article/${id}/top`)
}

// ==================== 权限管理 ====================

/**
 * 查询权限配置
 */
export function getKbPermissions(params) {
  return request.get('/kb/permissions', { params })
}

/**
 * 新增权限
 */
export function createKbPermission(data) {
  return request.post('/kb/permissions', data)
}

/**
 * 修改权限
 */
export function updateKbPermission(id, data) {
  return request.put(`/kb/permissions/${id}`, data)
}

/**
 * 删除权限
 */
export function deleteKbPermission(id) {
  return request.delete(`/kb/permissions/${id}`)
}

/**
 * 批量设置权限
 */
export function batchSetKbPermissions(data) {
  return request.post('/kb/permissions/batch', data)
}
